/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CardCanceled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M21.4697 22L18.939 19.4693L1 19.4697V3.46967L2.939 3.46934L1.46967 2L2.46967 1L22.4697 21L21.4697 22ZM7.059 3.469L23 3.46967V19.409L21.5 17.909V9.96867L13.559 9.968L11.059 7.468L21.5 7.46967V4.96967L8.559 4.969L7.059 3.469ZM9.438 9.96834L2.5 9.96867V17.9697L17.439 17.9693L9.438 9.96834ZM10 14.9697V16.4697H4V14.9697H10ZM4.439 4.96934L2.5 4.96967V7.46867L6.938 7.46834L4.439 4.96934Z"
                        fill={color}
                    />
                </svg>
        );
    };
